import { Component, OnInit, inject ,Inject} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AmplifyUser } from '@aws-amplify/ui';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { ConfigService } from 'src/app/config.service';
import { AuthService } from 'src/app/services/auth.service';
import { TUI_IS_MOBILE } from "@taiga-ui/cdk";
import { Auth } from 'aws-amplify';
import { BalanceService } from 'src/app/services/balance.service';
import { VerifyNumberComponent } from '../../my-profile/verify-number/verify-number.component';
import { AWSLambda } from 'src/app/AWSLambda.service';
import { Router, ActivatedRoute } from '@angular/router';
import {BoRolesCheckService} from "../../../components/rolesCheck/bo-roles-check.service";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-my-profile',
  templateUrl: './user-profile.component.html',
})
export class BOUserProfileComponent implements OnInit {
  user!: AmplifyUser;
  //authenticatorSvc = inject(AuthenticatorService);
  //auth = inject(AuthService);
  lambda = inject(AWSLambda);
  dialog = inject(MatDialog);
  _snackBar = inject(MatSnackBar);
  transfersUrl = `${inject(ConfigService).config.transfersUrl}?tracker=${inject(AuthService).getUser().id}`;
  private balanceSvc = inject(BalanceService);
  rolesCheck = inject(BoRolesCheckService);
  canAccess = false;
  userData : any;
  loading = true;
  currentUserId: string = '';
  balanceAmount: number | null = null;

  name: string | undefined;
  phone_number: string | undefined;
  email: string | undefined;

  middle_name: string | undefined;
  address: string | undefined;
  country: string | undefined;

  ciudad: string | undefined;
  provincia: string | undefined;
  postcode: string | undefined;
  passport: string | undefined;

  balance!: number;
  currency: string = `EUR`;
  phone_number_verified= false ;
  isVerificationInProgress = false;

  constructor(
    @Inject(TUI_IS_MOBILE) public mobile: boolean,
    private authenticatorSvc: AuthenticatorService,
    private auth: AuthService,
    private router: Router,
    private route: ActivatedRoute
      ) {

      }

  async ngOnInit() {
    this.canAccess = await this.rolesCheck.checkAccess();
    if (!this.canAccess) {
      return;
    }

    try {
      const userToEditSub = this.route.snapshot.paramMap.get('userId') || sessionStorage.getItem('boUserEdit');
      this.currentUserId = userToEditSub || '';
      sessionStorage.setItem('back_url', this.currentUserId ? `/backoffice/users/${this.currentUserId}` : '/backoffice/users');

      if (!userToEditSub) {
        this._snackBar.open('No se ha encontrado el usuario', 'Close', {
          duration: 5000,
        });
        this.router.navigate(['/backoffice/users']);
        return;
      }

      const data = await this.lambda.getLambdaFunction("lambda", "/get/userDetails", {
        queryStringParameters: {
          sub: userToEditSub
        }
      });

      console.log(data);
      this.userData = data;

      this.ciudad = data['custom:ciudad'];
      this.provincia = data['custom:provincia'];
      this.postcode = data['custom:postcode'];
      this.passport = data['custom:passport'];

      if (data?.['name'] == undefined || data?.['name'] == ' ') {
        this.name = '';
      } else {
        this.name = data?.['name'] + ' ' + data?.['middle_name'];
      }

      if (data?.['phone_number'] != undefined) {
        this.phone_number = data?.['phone_number'];
      }
      if (data?.['email'] != undefined) {
        this.email = data?.['email'];
      }
      if (data?.['middle_name'] != undefined) {
        this.middle_name = data?.['middle_name'];
      }
      if (data?.['custom:address'] != undefined) {
        this.address = data?.['custom:address'];
      }
      if (data?.['custom:country'] != undefined) {
        this.country = data?.['custom:country'];
      }

      this.phone_number_verified = data?.['phone_number_verified'] === 'true';
    } catch (error) {
      this.auth.logout();
    }

      await this.getbalance(this.currentUserId);

    this.loading = false;
  }

  onEdit() {
    if (this.currentUserId) {
      this.router.navigate(['/backoffice/users/edit', this.currentUserId]);
    } else {
      this._snackBar.open('No se puede editar: Usuario no identificado', 'Close', {
        duration: 5000,
      });
    }
  }

  onBalance() {
    this.router.navigate(['/backoffice/transactions'], {
      queryParams: { owner: this.currentUserId },
    });
  }

  addBalance(){
    this.router.navigate(['/backoffice/addbalance'], {
      queryParams: { user: this.currentUserId },
    });
  }

  addtravelsim(){
    this.router.navigate(['/backoffice/users', this.currentUserId, 'gift-esim']);
  }

  onViewEsims(){
    this.router.navigate(['/backoffice/users/esims', this.currentUserId]);
  }

  openVerification() {
    // Send an code to Signalwire
    console.log('> openVerification:userData:', this.userData);
    this.isVerificationInProgress = true;
    this.lambda.getLambdaFunction("lambda", "/aws/verification/send", {
      queryStringParameters: { phone_number: this.userData?.phone_number, lang: this.userData?.['locale'] ? this.userData?.['locale'] : 'es' },
    }).then( (data) => {
        this.dialog
          .open(VerifyNumberComponent, {
            data: Object.assign({}, data, { phone_number: this.userData?.phone_number })
          })
          .afterClosed()
          .subscribe(() => {
            // Recargar la página después de que el diálogo se haya cerrado
            window.location.reload();
          });
    }).catch( () => {
      // Error
    }).finally(() => {
      // Habilitar el botón de nuevo después de que se complete la operación
      this.isVerificationInProgress = false;
    });
  }

  onDelete() {
    console.log('> delete user')
  }

  goBack() {
    this.router.navigate(['/backoffice/users']);
  }

  async getbalance(owner: string) {
  try {
    const response = await this.lambda.getLambdaFunction('lambda', '/transactions/balance', {
      queryStringParameters: {
        owner,
        phoneNumber: this.phone_number,
        action:"get"
      }
    });
    this.balanceAmount = response.amount;
  } catch (err) {
    console.error("Error al obtener el balance:", err);
    this.balanceAmount = null;
  }
}

}
